import { useEffect } from 'react';

export function useSubscription(observable, subCondition = true) {
    useEffect(() => {
        let subscription;
        if (subCondition) {
            subscription = observable.subscribe();
            return () => subscription.unsubscribe();
        }
    }, [observable, subCondition]);
}

export function compareValues(key, order = 'asc') {
    return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            return 0;
        }
        let hasDate = false;
        let valueA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
        let valueB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];
        if (
            valueA &&
            typeof valueA === 'string' &&
            valueA.match(/\d{2}\/\d{2}\/\d{4}(\s\d{2}:\d{2}:\d{2})?/g)
        ) {
            let splited = valueA.split(' ');
            let arr = splited[0].split('/');
            valueA = arr[2] + arr[1] + arr[0] + (splited[1] ? splited[1].replace(/\D/g, '') : '');
            valueA = parseInt(valueA);
            hasDate = true;
        }
        if (
            valueB &&
            typeof valueB === 'string' &&
            valueB.match(/\d{2}\/\d{2}\/\d{4}(\s\d{2}:\d{2}:\d{2})?/g)
        ) {
            let splited = valueB.split(' ');
            let arr = splited[0].split('/');
            valueB = arr[2] + arr[1] + arr[0] + (splited[1] ? splited[1].replace(/\D/g, '') : '');
            valueB = parseInt(valueB);
            hasDate = true;
        }

        if (hasDate && valueA === 'NÃO CONFIGURADO') valueA = 0;
        if (hasDate && valueB === 'NÃO CONFIGURADO') valueB = 0;

        let comparison = 0;
        if (valueA > valueB) {
            comparison = 1;
        } else if (valueA < valueB) {
            comparison = -1;
        }
        return order === 'desc' ? comparison * -1 : comparison;
    };
}

export function arrayShuffle(a) {
    let j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
}

export function maskCurrency(value) {
    return value
        .toString()
        .replace(/\D/g, '')
        .replace(/(\d{1,2})$/, ',$1')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

export function camelToKebab(str) {
    return str
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
        .toLowerCase();
}

export function paramsToSearchURL(params, shouldConvertToKebab = true) {
    return Object.keys(params)
        .map((key) => (shouldConvertToKebab ? camelToKebab(key) : key) + '=' + params[key])
        .join('&');
}

export function getURLParameters(url) {
    return (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
        // eslint-disable-next-line no-sequences
        (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a),
        {}
    );
}

export function truncateString(str, num) {
    return str.length > num ? str.slice(0, num > 3 ? num - 3 : num) + '...' : str;
}

export function orderBy(arr, props, orders, orderFunc) {
    return [...arr].sort((a, b) =>
        props.reduce((acc, prop, i) => {
            if (acc === 0) {
                const [p1, p2] = orders && orders[i] === 'desc' ? [b[prop], a[prop]] : [a[prop], b[prop]];
                acc = orderFunc ? orderFunc(p1, p2, prop) : p1 > p2 ? 1 : p1 < p2 ? -1 : 0;
            }
            return acc;
        }, 0)
    );
}

export function toQuery(params) {
    const query = [];
    for (const key in params) {
        if (params[key] && typeof params[key] === 'string') {
            query.push(`${key}=${params[key].split('/').reverse().join('')}`);
        } else if (params[key]) {
            query.push(`${key}=${params[key]}`);
        }
    }

    return query.length > 0 ? query.join('&') : '';
}
export function arrayChunk(arr, size) {
    return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
        arr.slice(i * size, i * size + size),
    );
}
